export default __webpack_public_path__ + "static/media/question_mark_icon.d30a77a2.png";